import { Control, FieldValues, UseFormSetValue } from "react-hook-form";

import { IFormAttributes, PriceRateAdditionPricingType } from "@ryde/shared";

export interface IPriceLevelItem {
  from: number | null;
  price: number | null;
}

export interface IPriceLevelItemItemForm {
  pricingType: PriceRateAdditionPricingType;
  fromValues: number[];
  fieldName: string;
  control?: Control;
  index?: number;
  onEdit?: () => void;
  onCancelOuter?: () => void;
  value?: Partial<IPriceLevelItem>;
  setValueOuter?: UseFormSetValue<FieldValues>;
  removeHandler?: (index: number) => void;
  formAttributes?: IFormAttributes | null;
  disabledEdit?: boolean;
  disabledRemove?: boolean;
}

export const emptyPriceLevel: IPriceLevelItem = {
  from: null,
  price: null,
};

export const priceLevelFormFieldNames: (keyof IPriceLevelItem)[] = [
  "from",
  "price",
];

export const priceLevelSerialized = (item: IPriceLevelItem): string => {
  return `${item?.from || ""}-${item?.price} `;
};
